import { render, staticRenderFns } from "./CourierMobileOrders.vue?vue&type=template&id=a94fa1d8&scoped=true"
import script from "./CourierMobileOrders.vue?vue&type=script&lang=js"
export * from "./CourierMobileOrders.vue?vue&type=script&lang=js"
import style0 from "./CourierMobileOrders.vue?vue&type=style&index=0&id=a94fa1d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94fa1d8",
  null
  
)

export default component.exports
import {QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSkeleton})
